import type { SlideProps } from "@/engine/app/offsite-config";

export function Slide23Cliffhanger(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 460,
          height: 460,
          top: "-140px",
          left: "30%",
          background: "var(--svo-blau)",
          opacity: 0.30,
        }}
      />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 320,
          height: 320,
          bottom: "-100px",
          right: "5%",
          background: "var(--svo-gruen)",
          opacity: 0.10,
          animationDelay: "4s",
        }}
      />

      <header className="deck-head" style={{ textAlign: "center", margin: "0 auto" }}>
        <div className="deck-eyebrow rise rise-1">Reveal</div>
      </header>

      <div className="deck-hero">
        <div className="hero-sub rise rise-2" style={{ color: "rgba(255,255,255,0.88)" }}>
          Während wir geredet haben, hat die KI aus euren Anforderungen
          Prototypen gebaut.
        </div>
        <div
          className="rise rise-3"
          style={{
            fontSize: "clamp(3rem, 7vw, 6.5rem)",
            fontWeight: 200,
            color: "var(--svo-blau)",
            lineHeight: 1,
            letterSpacing: "-0.03em",
          }}
        >
          Schauen wir mal.
        </div>
        <div className="hero-divider rise rise-4" aria-hidden="true" />
      </div>
    </div>
  );
}
